import { PersistConfig } from 'redux-persist';
import { CookieStorage, CookiesAdapter } from 'redux-persist-cookie-storage';
import { StateFromReducersMapObject } from 'redux';
import { catalogItemViewReducerPath } from 'src/features/catalogItem';
import { uxReducerPath } from 'src/shared/ux';
import { reducerConfig } from './slices';

interface ReduxPersistConfigCreatorOptions {
  cookiesAdapter: CookiesAdapter;
}

interface ReduxPersistConfigCreator {
  (options: ReduxPersistConfigCreatorOptions): PersistConfig<StateFromReducersMapObject<typeof reducerConfig>>;
}

export const createReduxPersistConfig: ReduxPersistConfigCreator = ({ cookiesAdapter }) => ({
  key: 'root',
  storage: new CookieStorage(cookiesAdapter),
  // Here should be added names of preserved redux store slices
  whitelist: [catalogItemViewReducerPath, 'agreements', uxReducerPath],
  blacklist: ['_persist'],
});
